export default "__VITE_ASSET__2150cabe__"